var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19a9 9 0 100-18 9 9 0 000 18z",
    stroke: "#4CA80D",
    strokeWidth: 1.5,
    strokeDasharray: 63
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "-63;0",
    dur: "500ms",
    repeatCount: 1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.063 9.814L8.8 12.812l5.137-5.624",
    stroke: "#4CA80D",
    strokeWidth: 1.5,
    strokeDasharray: 40
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "40;40",
    dur: "300ms",
    repeatCount: 1
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "40;0",
    begin: "300ms",
    dur: "1200ms",
    repeatCount: 1
  }))));
}
export default SvgSuccessCheck;